var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.singleAccountLogin
    ? _c(
        "v-row",
        { staticClass: "auth-background ta-c login-page" },
        [
          _vm.loading
            ? _c("v-col", [
                _c("img", {
                  staticClass: "truck-loader",
                  attrs: { src: _vm.loading_truck },
                }),
              ])
            : _vm._e(),
        ],
        1
      )
    : _c(
        "v-row",
        { staticClass: "multi-accounts-background ta-c login-page" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                [
                  _c("v-col", { staticClass: "ta-c mt-5 pt-16" }, [
                    _c("label", { staticClass: "hello-lbl" }, [
                      _vm._v(_vm._s(_vm.greeting) + "!"),
                    ]),
                  ]),
                  _c("v-col", { staticClass: "my-4", attrs: { cols: "12" } }, [
                    _c("label", { staticClass: "a-few-things-lbl" }, [
                      _vm._v("A few things first before we start..."),
                    ]),
                  ]),
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("img", {
                      attrs: { src: require("@/assets/images/rocket.svg") },
                    }),
                  ]),
                  _c("v-col", { staticClass: "my-4", attrs: { cols: "12" } }, [
                    _c("label", { staticClass: "a-few-things-lbl" }, [
                      _vm._v(
                        "Please choose the account you wish to log in with"
                      ),
                    ]),
                  ]),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-row",
                        _vm._l(_vm.users, function (u) {
                          return _c(
                            "v-col",
                            { key: u.accountId, attrs: { cols: "12" } },
                            [
                              _c(
                                "v-row",
                                { attrs: { justify: "center" } },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ta-c",
                                      attrs: { cols: "3" },
                                    },
                                    [
                                      _c("v-hover", {
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var hover = ref.hover
                                                return [
                                                  _c(
                                                    "v-card",
                                                    {
                                                      staticClass: "br-8",
                                                      attrs: {
                                                        elevation: hover
                                                          ? 6
                                                          : 4,
                                                        hover: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.accountSelected(
                                                            u
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-card-text",
                                                        [
                                                          _c(
                                                            "v-row",
                                                            {
                                                              attrs: {
                                                                "no-gutters":
                                                                  "",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "hover account-info b",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          u.companyName
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "hover account-info",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          u.accountId
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }